// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overall_header_panel {
    padding-left: 60px;
    padding-top: 34px;
    padding-right: 60px;
}
.background_area {
    background-color: #fff;
    width: 100%;
    padding-bottom: 70px;
}
/* .logo {
    height: 30px;
    width: 45px;
    float: left;
    margin-right: 72px;
} */
/* .menu_items{font-size: 16px; font-weight: medium; color:#000; padding-left:14px; padding-right:14px; border-bottom: 3px solid #000; //down arrow height 2.5px in #000;} */
/* .user_profile{ height: 45px; width: 45px;  border-radius: 50%; background-color: #fff; box-shadow: 1.935px 7.762px 10px 0px rgba(142, 142, 142, 0.63); float: right;} */
.text_acquiredream {
    font-size: 50px;
    font-weight: regular;
    color: #000;
    text-align: center;
}
.text_findbestbusiness {
    font-size: 23px;
    font-weight: regular;
    color: #000;
    text-align: center;
}

.search {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.search_label_text {
    font-size: 17px;
    font-weight: regular;
    color: #cecece;
    text-align: left;
}
.search_input {
    background-color: #fff;
    color: #333;
    font-weight: medium;

    font-size: 17px;
    box-shadow: 2.661px 10.673px 32px 0px rgba(14, 13, 13, 0.21);
    width: 580px;
    height: 48px;
}
.placeholder {
    font-size: 17px;
    color: #c6c6c6;
    font-weight: medium;
    width: 540px;
    height: 48px;
    border: none;
}
.search_icon {
    padding-right: 21px;
    vertical-align: center;
    height: 17px;
    width: 17px;
}
.label-left {
    padding-top: 15px;
    font-size: 17px;
    font-weight: regular;
    color: rgb(250, 243, 243);
    float: right;
}

.background {
    height: 387px;
    width: 100%;
    margin-top: 65px;
    position: absolute;
    object-fit: cover;
}

.overlay-img {
    height: 387px;
    width: 100%;
    background-color: #000;
    opacity: 0.65;
    margin-top: 65px;
    position: absolute;
}

.search-bar-width {
    width: 50%;
}

@media (max-width: 768px) {
    .search-bar-width {
        width: 75%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/company/landingPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,oBAAoB;AACxB;AACA;;;;;GAKG;AACH,4KAA4K;AAC5K,0KAA0K;AAC1K;IACI,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;;IAEnB,eAAe;IACf,4DAA4D;IAC5D,YAAY;IACZ,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".overall_header_panel {\n    padding-left: 60px;\n    padding-top: 34px;\n    padding-right: 60px;\n}\n.background_area {\n    background-color: #fff;\n    width: 100%;\n    padding-bottom: 70px;\n}\n/* .logo {\n    height: 30px;\n    width: 45px;\n    float: left;\n    margin-right: 72px;\n} */\n/* .menu_items{font-size: 16px; font-weight: medium; color:#000; padding-left:14px; padding-right:14px; border-bottom: 3px solid #000; //down arrow height 2.5px in #000;} */\n/* .user_profile{ height: 45px; width: 45px;  border-radius: 50%; background-color: #fff; box-shadow: 1.935px 7.762px 10px 0px rgba(142, 142, 142, 0.63); float: right;} */\n.text_acquiredream {\n    font-size: 50px;\n    font-weight: regular;\n    color: #000;\n    text-align: center;\n}\n.text_findbestbusiness {\n    font-size: 23px;\n    font-weight: regular;\n    color: #000;\n    text-align: center;\n}\n\n.search {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n.search_label_text {\n    font-size: 17px;\n    font-weight: regular;\n    color: #cecece;\n    text-align: left;\n}\n.search_input {\n    background-color: #fff;\n    color: #333;\n    font-weight: medium;\n\n    font-size: 17px;\n    box-shadow: 2.661px 10.673px 32px 0px rgba(14, 13, 13, 0.21);\n    width: 580px;\n    height: 48px;\n}\n.placeholder {\n    font-size: 17px;\n    color: #c6c6c6;\n    font-weight: medium;\n    width: 540px;\n    height: 48px;\n    border: none;\n}\n.search_icon {\n    padding-right: 21px;\n    vertical-align: center;\n    height: 17px;\n    width: 17px;\n}\n.label-left {\n    padding-top: 15px;\n    font-size: 17px;\n    font-weight: regular;\n    color: rgb(250, 243, 243);\n    float: right;\n}\n\n.background {\n    height: 387px;\n    width: 100%;\n    margin-top: 65px;\n    position: absolute;\n    object-fit: cover;\n}\n\n.overlay-img {\n    height: 387px;\n    width: 100%;\n    background-color: #000;\n    opacity: 0.65;\n    margin-top: 65px;\n    position: absolute;\n}\n\n.search-bar-width {\n    width: 50%;\n}\n\n@media (max-width: 768px) {\n    .search-bar-width {\n        width: 75%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
